<template>
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.16663 4V2C6.16663 1.44772 6.61434 1 7.16663 1H9.16663C9.71891 1 10.1666 1.44772 10.1666 2V4M5.16663 13.5H4.66663C4.11434 13.5 3.66663 13.0523 3.66663 12.5V5C3.66663 4.44772 4.11434 4 4.66663 4H11.6666C12.2189 4 12.6666 4.44772 12.6666 5V12.5C12.6666 13.0523 12.2189 13.5 11.6666 13.5H11.1666M5.16663 13.5V15M5.16663 13.5H11.1666M11.1666 13.5V15M6.66663 6V11.5M9.66663 6V11.5"
      stroke="var(--icon-border-default)"
      stroke-width="1.1"
    />
  </svg>
</template>
